import React from 'react'
import {
  FooterCopyright,
  FooterExternalLink,
  FooterInternalLink,
  FooterLi,
  FooterList,
  Separator,
  StyledBottomFooter,
  StyledFooter,
} from './Footer.styled'
import PropTypes from 'prop-types'
import FooterNetwork from '../FooterNetwork/FooterNetwork'
import useCtaLink from '../../hooks/useCtaLink'
import useMediaQuery from '../../hooks/useMediaQuery'
import { deviceMax } from '../../theme/breakpoints'
import RoutingEnum from '../../routes/appRoutes'
import { Link } from 'gatsby'

const Footer = ({ footerLinks, light }) => {
  const isMobile = useMediaQuery(deviceMax.mobileL)
  const copyrightDate = new Date().getFullYear()
  const copyright = `Copyright © ${copyrightDate} All rights reserved`

  const footerNav = footerLinks.map((link, index, array) => {
    const [url, slug] = useCtaLink(link.url)
    const Link = slug ? FooterInternalLink : FooterExternalLink

    return (
      <FooterLi key={link.id}>
        <Link to={slug} href={url}>
          {link.label}
        </Link>
        <Separator />
        {/*{array.length - 1 !== index && <Separator/>}*/}
      </FooterLi>
    )
  })


  return (
    <StyledFooter id="footer" role="contentinfo">
      <FooterNetwork isMobile={isMobile} light={light} />
      <StyledBottomFooter>
        {!light && (
          <FooterList>
            {footerNav}
            <FooterLi key={'cookie-policy'}>
              <Link to={RoutingEnum.cookiePolicy}>Cookie Policy</Link>
            </FooterLi>
          </FooterList>
        )}
        {isMobile && !light && <Separator />}
        <FooterCopyright $light={light}>{copyright}</FooterCopyright>
      </StyledBottomFooter>
    </StyledFooter>
  )
}

Footer.propTypes = {
  footerLinks: PropTypes.array.isRequired,
}

export default Footer
